import { Controller } from '@hotwired/stimulus'
import * as analytics from '../../libs/analytics'
import NavigationSource from '../../libs/navigation_source'

export default class extends Controller {
  static values = {
    lessonId: Number,
    schoolClassId: Number
  }

  connect() {
    this.navigationSource = new NavigationSource(this.element)
  }

  disconnect() {
    this.navigationSource.stop()
  }

  // Previews render passively on page load, so "started" means first navigation,
  // not first render.
  slideChanged({ detail }) {
    if (!this.started) {
      this.started = true
      this.capture('preview_started', { total_slides: detail.totalSlides })
    }

    this.capture('slide_changed', {
      slide_index: detail.index,
      direction: detail.index >= detail.previousIndex ? 'forward' : 'backward',
      source: detail.source ?? this.navigationSource.consume(),
      total_slides: detail.totalSlides
    })
  }

  capture(event, properties) {
    analytics.capture(event, {
      mode: 'preview',
      lesson_id: this.lessonIdValue,
      school_class_id: this.schoolClassIdValue || undefined,
      ...properties
    })
  }
}
